import Slider from '../Slider/Slider';
import { useEffect, useRef } from 'react';
import {
	SliderWrap, RangeValueWrap, RangeWrap, ToolHeaderMainWrap,
	EditButtonLaptop, EditButtonMobile, EditButtonWrap, AdjustPanelWrap, AdjustPanelHeading, InfoText,
	SliderWithToggleDiv,
	ToolHeader,
} from './styles';
import OffsetModal from '../OffsetModal/';
import { useRefDispatch } from 'contexts/RefContext';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import DeleteModal from 'components/tool/Editor/DeleteModal';
import EditFacetModal from 'components/tool/Editor/EditFacetModal';
import ChangeOrientation from 'components/tool/Editor/ChangeOrientation';

import Show3DButton from 'components/ThreeDImage/Show3DButton';
import { EditButtonDiv } from 'components/tool/Editor/ButtonDiv';
import WarningModal from 'components/tool/Editor/WarningModal';
import EditorToolBar from 'components/tool/Editor';
import SwitchProvider from 'components/SwitchProvider';
import FullViewBtn from 'components/tool/Editor/ButtonDiv/FullViewBtn';
import ShadingConfirmationModal from 'components/tool/Editor/EditFacetModal/shadingConfirmationModal';
import RecalculateFacetLayoutModal from 'components/tool/Editor/EditFacetModal/RecalculateLayoutConfirmationModal';
import RecalculateLayoutModal from 'components/tool/Editor/RecalculateLayoutModal';
import { useOrgTheme } from 'contexts/ThemeContext';
import ResetChangesModal from 'components/tool/Editor/ResetChangesModal';
import GetDebugDataBtn from 'components/tool/Editor/ButtonDiv/GetDebugDataBtn';
import KeyboardShortcutsBtn from 'components/KeyboardShortcuts';
import DevModeBtn from 'components/tool/Editor/ButtonDiv/DevModeBtn';
import ResetTransitions from 'components/tool/Editor/EditFacetModal/ResetTransitions';
import { BREAK_POINT_FOR_MOBILE_VIEW, DESIGN_MODES } from '../../constants';
import DebugDialog from 'components/tool/Editor/DebugDialog';
import FullModeSwitchWarningModal from 'components/tool/Editor/EditFacetModal/FullModeSwitchWarningModal';
import AdjustPanelColorToggle from 'components/DisplayEnergy/PanelComponent/AdjustPanelColorToggle';
import useScreenDims from 'hooks/useScreenDims';
import SolarToolOptions from './SolarToolOptions';
import ToolTypeSwitchToggle from './ToolTypeSwitchToggle';
import AdjustShadingWarningModal from 'components/tool/Editor/AdjustShadingWarningModal';
import AzimuthExceedWarningModal from 'components/tool/Editor/AzimuthExceedWarningModal';
import RoofToolOptions from './RoofToolOptions';
import ToggleSatelliteViewBtn from 'components/tool/Editor/ButtonDiv/ToggleSatelliteViewBtn';

export default function ToolWithSilder() {
	const ref = useRef<HTMLInputElement | null>(null);
	const refDispatch = useRefDispatch();
	const { showIrradiance } = useSelector((state: RootState) => state.Irradiance.data);
	const { org, mode, designType } = useSelector((state: RootState) => state.roofData.data);
	const allowedActions = useSelector((state: RootState) => state.roleState.data.allowedActions);
	const { editModeEnabled, fullScreenEnabled } = useSelector((state: RootState) => state.toolNewPostions.data);
	const { toolType: reqToolType, billAmount } = useSelector((state: RootState) => state.QueryParams.data);

	const showAdjustPanelSlider = !editModeEnabled && !showIrradiance && designType === 'SOLAR' 
		&& (allowedActions.includes('toggle-panels') || org.setting.isB2C);
	const { adjustPanelText, adjustSystemSizeText } = useOrgTheme();

	const { width: screenWidth } = useScreenDims();
	const isMobileView = screenWidth <= BREAK_POINT_FOR_MOBILE_VIEW;
	const showSwitchToolTypeToggle = ['roofwithsolar', 'solarwithroof'].includes(reqToolType);

	useEffect(() => {
		refDispatch({ type: 'ADD_SLIDER_REF', payload: { ref } });
	}, [refDispatch]);

	return (
		<>
			<OffsetModal />
			<DeleteModal />
			<ChangeOrientation />
			<DebugDialog />
			<EditFacetModal />
			{/* <InfoModal/> */}
			<WarningModal />
			<RecalculateLayoutModal />
			<ResetChangesModal />
			<ResetTransitions />
			<ShadingConfirmationModal />
			<RecalculateFacetLayoutModal />
			<FullModeSwitchWarningModal />
			<AdjustShadingWarningModal/>
			<AzimuthExceedWarningModal/>

			{/* TODO : discuss placement for tooltype toggle if tool-type is solarwithroof */}
			<ToolHeader className={`
				${designType === 'ROOF'? 'roof-tool': ''}
				${editModeEnabled ? 'EnableModeViewWrapper' : 'NonViewWrapper'}`}>

				<SliderWrap isB2C={!!org?.setting?.isB2C}
					className={`${editModeEnabled ? 'EnableSliderWrapper' : 'NonEnableSliderWrapper'} ${adjustSystemSizeText ? 'eqadjustWrap' : ''}`}>
					
					{
						!org?.setting?.isB2C && (
							<EditButtonWrap > 
								<EditButtonDiv />
							</EditButtonWrap>
						)
					}

					{editModeEnabled ?
						<>
							{!showIrradiance && 
								<EditorToolBar designType={designType} />
							}
						</> :
						// Edit off mode
						<>
							{!org?.setting?.isB2C && <EditButtonLaptop >
								<SwitchProvider />
							</EditButtonLaptop>}
							{/* Todo */}

							{showAdjustPanelSlider &&
								<>
									<SliderWithToggleDiv>
										<AdjustPanelWrap className='sliderWithName' isB2C={!!org?.setting?.isB2C}>
											<AdjustPanelHeading className='adjust-panel-container'>
												<h3>{adjustPanelText}</h3>
											</AdjustPanelHeading>
											<RangeValueWrap>
												<RangeWrap>
													<Slider ref={ref} />
												</RangeWrap>
											</RangeValueWrap>
										</AdjustPanelWrap>

										{(!!org?.setting?.isB2C && isMobileView) && 
											<div className='panelColorToggle'><AdjustPanelColorToggle /></div>}

									</SliderWithToggleDiv>
									{!!adjustSystemSizeText && <InfoText>{adjustSystemSizeText}</InfoText>}
								</>
							}
						</>
					}
				</SliderWrap>

				{showSwitchToolTypeToggle && <ToolTypeSwitchToggle reqToolType={reqToolType} billAmount={billAmount}/>}
				
				{!org?.setting?.isB2C && 
					<ToolHeaderMainWrap className={editModeEnabled ? 'EnableModeView' : 'NonView'}>
						{!editModeEnabled && <EditButtonMobile ><SwitchProvider /></EditButtonMobile>}

						<ToolHeaderMainWrap className='mobile-view'>
							{designType === 'SOLAR' && 
								<SolarToolOptions 
									editModeEnabled={editModeEnabled}
									showIrradiance = {showIrradiance} 
								/>
							}
							{designType === 'ROOF' && 
								<RoofToolOptions />
							}

							{/* common tool options */}
							{(mode !== DESIGN_MODES.NEARMAP_NREL_MANUAL && !editModeEnabled) && <Show3DButton />}
							<KeyboardShortcutsBtn />
							<GetDebugDataBtn />
							<DevModeBtn />
							<ToggleSatelliteViewBtn />
							{fullScreenEnabled && <FullViewBtn />}
						</ToolHeaderMainWrap>
					</ToolHeaderMainWrap>}
			</ToolHeader>
		</>
	);
}